import { CellContext } from '@tanstack/react-table'
import * as React from 'react'
import { CheckinTableRow } from '../data'

export const TitleCell = (data: CellContext<CheckinTableRow, unknown>) => {
  const title = data.row.original.title
  if (!title) return '-'

  return (
    <div className="max-w-[240px] truncate" title={title}>
      {title}
    </div>
  )
}
